import * as claimApi from '../../api/claimApi';
import { mapApplicant } from '../../helpers/claims/propertyClaim';

const SEARCH_FOR_APPLICANT = 'efes/CLAIM/SEARCH_FOR_APPLICANT';
const SEARCH_FOR_APPLICANT_SUCCESS = 'efes/CLAIM/SEARCH_FOR_APPLICANT_SUCCESS';
const SEARCH_FOR_APPLICANT_FAIL = 'efes/CLAIM/SEARCH_FOR_APPLICANT_FAIL';
const CLEAR_APPLICANT_SEARCH = 'efes/CLAIM/CLEAR_APPLICANT_SEARCH';
const SET_APPLICANT_IS_ADULT = 'efes/CLAIM/SET_APPLICANT_IS_ADULT';
const SET_APPLICANT_FILLED_FIELDS = 'efes/CLAIM/SET_APPLICANT_FILLED_FIELDS';

const initialState = {
  isSearching: false,
  applicantIsAdult: null,
  searchData: {
    applicant: null,
    customError: null,
  },
  error: null,
  searchApplicantFilledFields: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SEARCH_FOR_APPLICANT:
      return {
        ...state,
        isSearching: true,
        searchData: { applicant: null, customError: null },
        error: null,
      };
    case SEARCH_FOR_APPLICANT_SUCCESS:
      return {
        ...state,
        isSearching: false,
        searchData: action.result,
      };
    case SEARCH_FOR_APPLICANT_FAIL:
      return {
        ...state,
        isSearching: false,
        searchData: { applicant: null, customError: null },
        error: action.error,
      };
    case SET_APPLICANT_IS_ADULT:
      return {
        ...state,
        applicantIsAdult: action.data,
      };
    case CLEAR_APPLICANT_SEARCH:
      return { ...initialState, applicantIsAdult: state.applicantIsAdult };
    case SET_APPLICANT_FILLED_FIELDS:
      return {
        ...state,
        searchApplicantFilledFields: action.data,
      };
    default:
      return state;
  }
}

export function searchForApplicant(data) {
  return {
    actions: [
      { type: SEARCH_FOR_APPLICANT },
      { type: SEARCH_FOR_APPLICANT_SUCCESS },
      { type: SEARCH_FOR_APPLICANT_FAIL, showError: true },
    ],
    promise: claimApi.searchForMedicalApplicant(data),
  };
}

export function searchForCascoApplicant(data) {
  return {
    actions: [
      { type: SEARCH_FOR_APPLICANT },
      { type: SEARCH_FOR_APPLICANT_SUCCESS },
      { type: SEARCH_FOR_APPLICANT_FAIL, showError: true },
    ],
    promise: claimApi.searchForCascoApplicant(data),
  };
}

export function searchForPropertyApplicant(data) {
  return {
    actions: [
      { type: SEARCH_FOR_APPLICANT },
      { type: SEARCH_FOR_APPLICANT_SUCCESS },
      { type: SEARCH_FOR_APPLICANT_FAIL, showError: true },
    ],
    promise: claimApi
      .searchForPropertyApplicant(data)
      .then((responseData) => {
        if (responseData.applicant) {
          return mapApplicant(responseData.applicant, data);
        }
        return {
          applicant: null,
          customError: responseData.customError,
        };
      }),
  };
}

export const setApplicantIsAdult = (data) => ({
  type: SET_APPLICANT_IS_ADULT,
  data,
});

export const setApplicantFilledFields = (data) => ({
  type: SET_APPLICANT_FILLED_FIELDS,
  data,
});

export const clearApplicantSearch = () => ({
  type: CLEAR_APPLICANT_SEARCH,
});
